import React from 'react';
import ReactDOM from 'react-dom';

import './assets/scss/index.scss';
import App from './components/App';
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

ReactDOM.render(<App />, document.getElementById('root'));
